import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import dayjs from 'dayjs'
import {DownloadIcon} from "../../../../../../icons";

export const toolbarActions = ({
                                 totalCount,
                                 exportFileExcel,
                                 isExcelExportLoading
                               }) => {
  let actions = []

  if (totalCount>0 && totalCount<=1000) {
    actions = [
      ...actions,
      {
        label: isExcelExportLoading ? 'Export in curs...' : 'Export Excel',
        icon: <DownloadIcon />,
        onClick: isExcelExportLoading ? () => {} : exportFileExcel
      }
    ]
  }

  return actions
}

export const getColumns = (canView: boolean, type: string) => [
  {
    title: 'Depozit',
    field: 'depositName',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Tip magazin',
    field: 'shopType',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Via',
    field: 'hubName',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Societate',
    field: 'parentSociety',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Data task magazin',
    field: 'created',
    align: 'left',
    type: 'date',
    width: '100px'
  },
  ...(type === 'finalised' || canView
    ? [
        {
          title: 'Data rezolvare task magazin',
          field: 'shopFinaliseTime',
          align: 'left',
          type: 'date',
          width: '100px'
        }
      ]
    : []),
  ...(type === 'finalised'
    ? [
        {
          title: 'Data rezolvare task depozit',
          field: 'depositFinaliseTime',
          align: 'left',
          type: 'date',
          width: '100px'
        }
      ]
    : []),
  {
    title: 'Notificari trimise catre magazin',
    field: 'sentNotifications',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Numar aviz magazin',
    field: 'noticeCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Data aviz magazin',
    field: 'noticeCreated',
    align: 'left',
    type: 'date',
    width: '100px'
  },
  {
    title: 'Status',
    field: 'status',
    align: 'left',
    type: 'string',
    width: '100px'
  }
]

export const getFilters = (depositOptions, hubOptions, shopOptions, parentSocietyOptions) => [
  {
    name: 'depositId',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează depozit"
        options={depositOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selectează depozit'
  },
  {
    name: 'hubId',
    value: undefined,
    filter: <Autocomplete variant="outlined" label="VIA" options={hubOptions || []} multiple />,
    type: 'autocomplete',
    label: 'VIA'
  },
  {
    name: 'noticeNumber',
    value: '',
    filter: <Input variant="outlined" label="Numar aviz magazin" type="text" />,
    type: 'text',
    label: 'Numar aviz magazin'
  },
  {
    name: 'noticeDate',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data aviz magazin"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data aviz magazin'
  },
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza magazin"
        options={shopOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selecteaza magazin'
  },
  {
    name: 'taskDate',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data task magazin"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data task magazin'
  },
  {
    name: 'expirationDate',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data expirare task magazin"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data expirare task magazin'
  },
  {
    name: 'parentSociety',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza societate"
        options={parentSocietyOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selecteaza societate'
  }
]
